module.exports = {
  findPwd: {
    find: '找回密碼',
    userName: '手機號或郵箱',
    error_userName_1: '請輸入手機號或郵箱',
    error_userName_2: '用戶不存在',
    get_code: '獲取驗證碼',
    get_code_tip: '點擊獲取驗證碼',
    get_code_tip_re: '秒後重新發送',
    code: '驗證碼',
    error_code_1: '請輸入驗證碼',
    error_code_2: '一天內發送驗證碼次數超過5次，今日無法再發送',
    error_code_3: '驗證碼錯誤',
    next: '下一步',
    input_password: '輸入新密碼',
    repeat_new_password: '重複新密碼',
    new_password_error: '兩次密碼不一致',
    submit_new_password: '提交新密碼',
    success_relogin: '密碼重置成功，請重新登錄',
    button_relogin: '重新登錄'
  },
  register: {
    register: '註冊',
    phone_register: '手機號註冊',
    email_register: '郵箱註冊',
    phone: '請輸入手機號碼',
    error_phone: '無效的手機號碼',
    already_bound: '用戶名已存在',
    not_support: '頻道不支持',
    code: '驗證碼',
    code_error: '驗證碼錯誤',
    get_code: '獲取驗證碼',
    get_code_tip_re: '秒後重新發送',
    error_code_1: '驗證碼不能為空',
    error_code_2: '一天內發送驗證碼次數超過5次，今日無法再發送',
    error_code_3: '驗證碼錯誤',
    error_code_4: '驗證碼已發送，10分鐘內有效，請勿重新發送',
    error_code_5: '請不要高頻請求驗證碼',
    password_set: '8-20位字母及數字組合密碼',
    password_error_1: '密碼不能為空',
    protocol_a: '我已閱讀並接受',
    protocol_b: '使用協議',
    submit: '提交',
    login_now: '立即登錄',
    success: '歡迎您註冊成者賬號，恭喜您賬號激活成功，請重新登陸！',
    login_re: '返回重新登錄',
    email: '請輸入郵箱',
    email_error: '郵箱格式不正確',
    email_already_bound: '該郵箱已經存在',
    accout_safe_tips: '為了您的賬號安全，請綁定手機',
    password_repeat: '重複6~20位密碼',
    bind: '綁定',
    password: '設置密碼'
  },
  success: {
    activation: '郵件已發送',
    activation_email: '您的激活郵件已發送至 ',
    click_email: '，點擊郵件內激活按鈕完成註冊。',
    active_email: '沒有收到確認郵件，鏈接過期， 怎麼辦？',
    email_help1: '● 看看是否會在回收站，垃圾郵件中？',
    email_help2: '● 重新發送，',
    activation_success: '激活成功',
    jumping_now: '立即跳轉',
    activation_failed: '鏈接過期',
    valueText: '點擊重新發送',
    jumpingText: '正在跳轉（',
    get_code_tip_re: '秒後重新發送',
    code_error1: '一天只能發送5次驗證碼',
    code_error2: '發送失敗'
  },
  index: {
    loginText: '登錄',
    userName: '手機號/郵箱',
    password: '密碼',
    forgetPwd: '忘記密碼',
    register: '註冊新用護',
    userTip: '請輸入手機號/郵箱',
    pwdTip: '請輸入密碼',
    loginFail: '用戶名或密碼錯誤',
    errorFormat: '格式不正確',
    inactive: '賬號未激活，請到郵箱激活',
    resend: '點此重發一封',
    success: '發送成功',
    info: '賬戶中心'
  },
  basic: {
    editText: '編輯',
    updateText: '修改',
    logoutText: '退出登錄',
    czurId: '成者ID',
    emailBind: '綁定郵箱',
    phone: '安全手機',
    password: '密碼',
    passwordSet: '(已設置)',
    bindText: '綁定',
    unbindText: '(未綁定)',
    navText: '個人中心',
    emailAddress: '郵箱地址',
    emailEmpty: '請輸入郵箱地址',
    emailInvalid: '無效的郵箱地址',
    emailBinds: '該郵箱已綁定其他賬號',
    codeEmpty: '請輸入驗證碼',
    codeError: '驗證碼錯誤',
    fiveTimes: '同一個郵箱，一天只能發送5次驗證碼',
    hasSent: '驗證碼已經被發送，它會在10min內有效',
    highFrequency: '請不要高頻請求驗證碼',
    emailCode: '郵箱驗證碼',
    emailSend: '发送验证码',
    Submit: '提交',
    sendAgain: '秒後重新發送',
    validateEmail: '驗證郵箱',
    emailSent: '已發送驗證碼到郵箱',
    nextStep: '下一步',
    successText: '修改成功',
    finishText: '完成',
    updatePwd: '修改密碼',
    oldPwd: '當前密碼',
    newPwd: '新密碼',
    confirmPwd: '確認新密碼',
    oldPwdInput: '請輸入當前密碼',
    newPwdInput: '請輸入新密碼',
    notSame: '新密碼不能與原密碼相同',
    confirmPwdInput: '請輸入確認密碼',
    notSameWith: '新密碼與確認密碼不一致',
    oldPwdInvalidate: '原密碼無效',
    notExist: '用戶不存在',
    fiveTime: '同一個手機號，一天只能發送5次驗證碼',
    validatePhone: '驗證手機號',
    phoneSent: '已發送驗證碼到手機',
    phoneCode: '短信驗證碼',
    phoneInput: '請輸入手機號碼',
    error_phone: '無效的手機號碼',
    already_bound: '該手機號已經綁定其他賬號',
    bindPhone: '綁定手機',
    phoneNum: '手機號碼',
    uploadImg: '上傳圖片',
    supportText: '只支持JPG, png, 大小不超過200KB',
    confirm: '確定',
    cancel: '取消',
    nicknameLong: '請輸入14字元以內昵稱',
    closeAcount: '註銷賬號',
    nicknameEmpty: '名字不能為空',
    nicknameEmoji: '禁止輸入特殊符號或表情',
    area: '地區',
    closeHint: '溫馨提示',
    closeText: '成者雲帳號為成者CZUR、極簡掃描、成者極簡掃描、Starry Meeting、Scanner通用帳號，註銷操作將會註銷以上所有帳號，請仔細確認。',
    closeWarning: '帳號一經註銷，將銷毀所有用戶數據，請謹慎操作！',
    close: '註銷',
    code: '驗證碼',
    slelctCountry: '選擇地區',
    lowPw: '你的密碼過於簡單，必須修改密碼後才能繼續',
    logout: '退出'

  },
  titleText: {
    account_center: '個人信息',
    privacy: '成者科技 - 隱私政策',
    create_account: '成者科技 - 註冊中心',
    terms_service: '成者科技 - 使用協議',
    find_pwd: '成者科技 - 找回密碼',
    active: '成者科技-激活',
    account_CZUR: '成者科技-賬號中心'
  }

}



// WEBPACK FOOTER //
// ./src/common/lang/zh_TW.js